// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"certificates_modalBodyStyle__-xKG8","modal":"certificates_modal__odzA3"};